import React from 'react';
import { Modal, Box, TextField } from '@mui/material';

import GridItem from '@/components/Grid/GridItem';
import GridContainer from '@/components/Grid/GridContainer';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';
import { modalStyle } from '@/views/Clients/Claim';
import { useStyles } from '@/styles/templateInputStyles';
import { useStylesDanger } from './FacilityTransaction/hooks';
import { ENTITY_TYPE } from '@/utility';
import FileList from './FileList';
import { useTranslation } from 'react-i18next';

const RefundInfoHistory = ({
  selectedForTrackChangesId,
  infoHistory,
  entityType,
  onClose,
}) => {
  const { t } = useTranslation();
  const labelStyle = {
    fontSize: '12px',
    color: 'grey',
  };
  const classes = useStyles();
  const dangerClass = useStylesDanger();

  const getClass = (info, index, input) => {
    const refundInfoHistory = infoHistory.filter(
      (info) => info.type === 'refund_info',
    );

    const historyItem = infoHistory[index];

    const infoHistoryIndex = refundInfoHistory.findIndex((historyInfo) => {
      return historyInfo.id === historyItem.id;
    });

    if (infoHistoryIndex === refundInfoHistory.length - 1) {
      return classes.root;
    }

    return info[input] != refundInfoHistory[infoHistoryIndex + 1][input]
      ? dangerClass.root
      : classes.root;
  };

  return (
    <Modal open={selectedForTrackChangesId ? true : false} onClose={onClose}>
      <Box
        sx={modalStyle}
        className='makeStyles-card-96'
        noValidate
        autoComplete='off'>
        <CardHeader style={{ transform: 'translateY(-50%)' }} color='primary'>
          <h4>{t('refundInfoHistory.title')}</h4>
        </CardHeader>
        <CardBody style={{ marginTop: '-40px', overflowY: 'scroll' }}>
          {infoHistory.map((info, index) => {
            if (info.type === 'refund_attachments') {
              const { filesAdded, filesRemoved } = info;

              return (
                <GridContainer key={index}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                    }}>
                    {!!filesAdded?.length && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          padding: '20px',
                          gap: '10px',
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '10px 0',
                            backgroundColor: 'rgba(0, 0, 0, 0.08)',
                            borderRadius: '5px',
                            padding: '10px',
                          }}>
                          <p style={{ fontSize: '14px' }}>
                            <b>{t('refundInfoHistory.filesAddedBy')}:</b>{' '}
                            {info.updated_by}
                          </p>
                          <p style={{ fontSize: '12px', marginTop: '-5px' }}>
                            <b>{t('refundInfoHistory.comment')}: </b>{' '}
                            {info.comment ?? 'N/A'}
                          </p>
                          <p style={{ fontSize: '12px', marginTop: '-5px' }}>
                            <b>{t('refundInfoHistory.modifiedLocation')}: </b>{' '}
                            {info.updated_at_location ?? 'N/A'}
                          </p>
                        </div>
                        <FileList files={filesAdded} />
                      </div>
                    )}
                    {!!filesRemoved?.length && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          padding: '20px',
                          gap: '10px',
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '10px 0',
                            backgroundColor: 'rgba(0, 0, 0, 0.08)',
                            borderRadius: '5px',
                            padding: '10px',
                          }}>
                          <p style={{ fontSize: '14px' }}>
                            <b>{t('refundInfoHistory.filesRemovedBy')}:</b>{' '}
                            {info.updated_by}
                          </p>
                          <p style={{ fontSize: '12px', marginTop: '-5px' }}>
                            <b>{t('refundInfoHistory.comment')}: </b>{' '}
                            {info.comment ?? 'N/A'}
                          </p>
                          <p style={{ fontSize: '12px', marginTop: '-5px' }}>
                            <b>{t('refundInfoHistory.modifiedLocation')}: </b>{' '}
                            {info.updated_at_location ?? 'N/A'}
                          </p>
                        </div>
                        <FileList files={filesRemoved} />
                      </div>
                    )}
                  </div>
                </GridContainer>
              );
            }

            return (
              <GridContainer key={index}>
                <GridItem style={{ marginTop: '20px' }} xs={12} sm={12} md={12}>
                  {index === 0 && (
                    <h5
                      style={{
                        background: '#3AB795',
                        padding: '5px',
                        borderRadius: '5px',
                        display: 'inline',
                        color: '#fff',
                        width: 'fit-content',
                        fontSize: '14px',
                        margin: 0,
                      }}>
                      {t('refundInfoHistory.latest')}
                    </h5>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      margin: '10px 0',
                      backgroundColor: 'rgba(0, 0, 0, 0.08)',
                      borderRadius: '5px',
                      padding: '10px',
                    }}>
                    <p style={{ fontSize: '14px' }}>
                      <b>{t('refundInfoHistory.updatedBy')}:</b>{' '}
                      {info.updated_by}
                    </p>
                    <p style={{ fontSize: '12px', marginTop: '-5px' }}>
                      <b>{t('refundInfoHistory.comment')}: </b>{' '}
                      {info.comment ?? 'N/A'}
                    </p>
                    <p style={{ fontSize: '12px', marginTop: '-5px' }}>
                      <b>{t('refundInfoHistory.modifiedLocation')}: </b>{' '}
                      {info.updated_at_location ?? 'N/A'}
                    </p>
                  </div>
                </GridItem>
                {entityType === ENTITY_TYPE.INDIVIDUAL ? (
                  <>
                    <GridItem xs={12} sm={12} md={6}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                        }}>
                        <label style={labelStyle}>
                          {t('refundInfoHistory.firstName')}
                        </label>

                        <TextField
                          variant='outlined'
                          className={getClass(info, index, 'first_name')}
                          multiline
                          inputProps={{
                            style: {
                              fontSize: '14px',
                              lineHeight: '1.3',
                              width: '100%',
                            },
                          }}
                          minRows={1}
                          maxRows={2}
                          value={info.first_name}
                          onChange={() => null}
                          name='cc'
                        />
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                        }}>
                        <label style={labelStyle}>
                          {t('refundInfoHistory.lastName')}
                        </label>
                        <TextField
                          variant='outlined'
                          id='component-error'
                          className={getClass(info, index, 'last_name')}
                          // color='danger'
                          multiline
                          inputProps={{
                            style: {
                              fontSize: '14px',
                              lineHeight: '1.3',
                              width: '100%',
                            },
                          }}
                          minRows={1}
                          maxRows={2}
                          value={info.last_name}
                          onChange={() => null}
                          name='cc'
                        />
                      </div>
                    </GridItem>
                  </>
                ) : (
                  <GridItem
                    style={{ marginTop: '20px' }}
                    xs={12}
                    sm={12}
                    md={12}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                      }}>
                      <label style={labelStyle}>
                        {t('refundInfoHistory.businessPayeeName')}
                      </label>
                      <TextField
                        variant='outlined'
                        className={getClass(info, index, 'business_payee_name')}
                        multiline
                        inputProps={{
                          style: {
                            fontSize: '14px',
                            lineHeight: '1.3',
                            width: '100%',
                          },
                        }}
                        minRows={1}
                        maxRows={1}
                        value={info.business_payee_name}
                        onChange={() => null}
                        name='cc'
                      />
                    </div>
                  </GridItem>
                )}

                <GridItem style={{ marginTop: '20px' }} xs={12} sm={12} md={12}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                    }}>
                    <label style={labelStyle}>
                      {t('refundInfoHistory.email')}
                    </label>
                    <TextField
                      variant='outlined'
                      className={getClass(info, index, 'email')}
                      multiline
                      inputProps={{
                        style: {
                          fontSize: '14px',
                          lineHeight: '1.3',
                          width: '100%',
                        },
                      }}
                      minRows={1}
                      maxRows={1}
                      value={info.email}
                      onChange={() => null}
                      name='cc'
                    />
                  </div>
                </GridItem>
                <GridItem style={{ marginTop: '20px' }} xs={12} sm={12} md={12}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                    }}>
                    <label style={labelStyle}>
                      {t('refundInfoHistory.memo')}
                    </label>
                    <TextField
                      variant='outlined'
                      className={getClass(info, index, 'memo')}
                      multiline
                      inputProps={{
                        style: {
                          fontSize: '14px',
                          lineHeight: '1.3',
                          width: '100%',
                        },
                      }}
                      minRows={1}
                      maxRows={1}
                      value={info.memo}
                      onChange={() => null}
                      name='cc'
                    />
                  </div>
                </GridItem>

                <GridItem style={{ marginTop: '20px' }} xs={12} sm={12} md={12}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                    }}>
                    <label style={labelStyle}>
                      {t('refundInfoHistory.address')}
                    </label>
                    <TextField
                      variant='outlined'
                      className={getClass(info, index, 'address')}
                      multiline
                      inputProps={{
                        style: {
                          fontSize: '14px',
                          lineHeight: '1.3',
                          width: '100%',
                        },
                      }}
                      minRows={4}
                      maxRows={6}
                      value={info.address}
                      onChange={() => null}
                      name='cc'
                    />
                  </div>
                </GridItem>
              </GridContainer>
            );
          })}
        </CardBody>
      </Box>
    </Modal>
  );
};

export default RefundInfoHistory;
